// assets
import abigailBasilio from './abigail-basilio.png'
import angeluzLRuelo from './angeluz-l-ruelo.png'
import annCarlenAFlores from './ann-carlen-a-flores.png'
import aprilPatigas from './april-patigas.png'
import armamieTancio from './armamie-tancio.png'
import bernadethAguado from './bernadeth-aguado.png'
import camilleIraBMendoza from './camille-ira-b-mendoza.png'
import ellaJaneIcawalo from './ella-jane-icawalo.png'
import estherDaka from './esther-daka.png'
import eugeneKashuk from './eugene-kashuk.png'
import florenceKhitsane from './florence-khitsane.png'
import franzJerbyDelosSantos from './franz-jerby-delos-santos.png'
import hannaChariseLanza from './hanna-charise-lanza.png'
import hannahZhylAraneta from './hannah-zhyl-araneta.png'
import jessicaKaminski from './jessica-kaminski.png'
import jhoverSQuiranteMaed from './jhover-s-quirante-maed.png'
import joAnnCaballes from './jo-ann-caballes.png'
import jomhelAgnote from './jomhel-agnote.png'
import lailaALico from './laila-a-lico.png'
import lalainePearlEstampa from './lalaine-pearl-estampa.png'
import larryMulig from './larry-mulig.png'
import mailaCaliao from './maila-caliao.png'
import marjorieAlvarezReano from './marjorie-alvarez-reano.png'
import maryGrace from './mary-grace.png'
import phoebeBelzaBarrientos from './phoebe-belza-barrientos.png'
import pinkyDumaguing from './pinky-dumaguing.png'
import preciousAngelPTaytay from './precious-angel-p-taytay.png'
import rachelleBencioYu from './rachelle-bencio-yu.png'
import rezanMaeAAlferez from './rezan-mae-a-alferez.png'
import susanBangloyPalacio from './susan-bangloy-palacio.png'
import tamayaGovender from './tamaya-govender.png'
import victoriaEdet from './victoria-edet.png'
import vinaMarieCataloctocan from './vina-marie-cataloctocan.png'
import abigailBasilioWebp from './abigail-basilio.webp'
import angeluzLRueloWebp from './angeluz-l-ruelo.webp'
import annCarlenAFloresWebp from './ann-carlen-a-flores.webp'
import aprilPatigasWebp from './april-patigas.webp'
import armamieTancioWebp from './armamie-tancio.webp'
import bernadethAguadoWebp from './bernadeth-aguado.webp'
import camilleIraBMendozaWebp from './camille-ira-b-mendoza.webp'
import ellaJaneIcawaloWebp from './ella-jane-icawalo.webp'
import estherDakaWebp from './esther-daka.webp'
import eugeneKashukWebp from './eugene-kashuk.webp'
import florenceKhitsaneWebp from './florence-khitsane.webp'
import franzJerbyDelosSantosWebp from './franz-jerby-delos-santos.webp'
import hannaChariseLanzaWebp from './hanna-charise-lanza.webp'
import hannahZhylAranetaWebp from './hannah-zhyl-araneta.webp'
import jessicaKaminskiWebp from './jessica-kaminski.webp'
import jhoverSQuiranteMaedWebp from './jhover-s-quirante-maed.webp'
import joAnnCaballesWebp from './jo-ann-caballes.webp'
import jomhelAgnoteWebp from './jomhel-agnote.webp'
import lailaALicoWebp from './laila-a-lico.webp'
import lalainePearlEstampaWebp from './lalaine-pearl-estampa.webp'
import larryMuligWebp from './larry-mulig.webp'
import mailaCaliaoWebp from './maila-caliao.webp'
import marjorieAlvarezReanoWebp from './marjorie-alvarez-reano.webp'
import maryGraceWebp from './mary-grace.webp'
import phoebeBelzaBarrientosWebp from './phoebe-belza-barrientos.webp'
import pinkyDumaguingWebp from './pinky-dumaguing.webp'
import preciousAngelPTaytayWebp from './precious-angel-p-taytay.webp'
import rachelleBencioYuWebp from './rachelle-bencio-yu.webp'
import rezanMaeAAlferezWebp from './rezan-mae-a-alferez.webp'
import susanBangloyPalacioWebp from './susan-bangloy-palacio.webp'
import tamayaGovenderWebp from './tamaya-govender.webp'
import victoriaEdetWebp from './victoria-edet.webp'
import vinaMarieCataloctocanWebp from './vina-marie-cataloctocan.webp'
// types
import type { TutorAvatarName } from '../types/interfaces'

export const TUTOR_AVATARS: Record<TutorAvatarName, string> = {
  'abigail-basilio': abigailBasilio,
  'angeluz-l-ruelo': angeluzLRuelo,
  'ann-carlen-a-flores': annCarlenAFlores,
  'april-patigas': aprilPatigas,
  'armamie-tancio': armamieTancio,
  'bernadeth-aguado': bernadethAguado,
  'camille-ira-b-mendoza': camilleIraBMendoza,
  'ella-jane-icawalo': ellaJaneIcawalo,
  'esther-daka': estherDaka,
  'eugene-kashuk': eugeneKashuk,
  'florence-khitsane': florenceKhitsane,
  'franz-jerby-delos-santos': franzJerbyDelosSantos,
  'hanna-charise-lanza': hannaChariseLanza,
  'hannah-zhyl-araneta': hannahZhylAraneta,
  'jessica-kaminski': jessicaKaminski,
  'jhover-s-quirante-maed': jhoverSQuiranteMaed,
  'jo-ann-caballes': joAnnCaballes,
  'jomhel-agnote': jomhelAgnote,
  'laila-a-lico': lailaALico,
  'lalaine-pearl-estampa': lalainePearlEstampa,
  'larry-mulig': larryMulig,
  'maila-caliao': mailaCaliao,
  'marjorie-alvarez-reano': marjorieAlvarezReano,
  'mary-grace': maryGrace,
  'phoebe-belza-barrientos': phoebeBelzaBarrientos,
  'pinky-dumaguing': pinkyDumaguing,
  'precious-angel-p-taytay': preciousAngelPTaytay,
  'rachelle-bencio-yu': rachelleBencioYu,
  'rezan-mae-a-alferez': rezanMaeAAlferez,
  'susan-bangloy-palacio': susanBangloyPalacio,
  'tamaya-govender': tamayaGovender,
  'victoria-edet': victoriaEdet,
  'vina-marie-cataloctocan': vinaMarieCataloctocan,
}

export const TUTOR_AVATARS_WEBP: Record<TutorAvatarName, string> = {
  'abigail-basilio': abigailBasilioWebp,
  'angeluz-l-ruelo': angeluzLRueloWebp,
  'ann-carlen-a-flores': annCarlenAFloresWebp,
  'april-patigas': aprilPatigasWebp,
  'armamie-tancio': armamieTancioWebp,
  'bernadeth-aguado': bernadethAguadoWebp,
  'camille-ira-b-mendoza': camilleIraBMendozaWebp,
  'ella-jane-icawalo': ellaJaneIcawaloWebp,
  'esther-daka': estherDakaWebp,
  'eugene-kashuk': eugeneKashukWebp,
  'florence-khitsane': florenceKhitsaneWebp,
  'franz-jerby-delos-santos': franzJerbyDelosSantosWebp,
  'hanna-charise-lanza': hannaChariseLanzaWebp,
  'hannah-zhyl-araneta': hannahZhylAranetaWebp,
  'jessica-kaminski': jessicaKaminskiWebp,
  'jhover-s-quirante-maed': jhoverSQuiranteMaedWebp,
  'jo-ann-caballes': joAnnCaballesWebp,
  'jomhel-agnote': jomhelAgnoteWebp,
  'laila-a-lico': lailaALicoWebp,
  'lalaine-pearl-estampa': lalainePearlEstampaWebp,
  'larry-mulig': larryMuligWebp,
  'maila-caliao': mailaCaliaoWebp,
  'marjorie-alvarez-reano': marjorieAlvarezReanoWebp,
  'mary-grace': maryGraceWebp,
  'phoebe-belza-barrientos': phoebeBelzaBarrientosWebp,
  'pinky-dumaguing': pinkyDumaguingWebp,
  'precious-angel-p-taytay': preciousAngelPTaytayWebp,
  'rachelle-bencio-yu': rachelleBencioYuWebp,
  'rezan-mae-a-alferez': rezanMaeAAlferezWebp,
  'susan-bangloy-palacio': susanBangloyPalacioWebp,
  'tamaya-govender': tamayaGovenderWebp,
  'victoria-edet': victoriaEdetWebp,
  'vina-marie-cataloctocan': vinaMarieCataloctocanWebp,
}
